module.exports = __webpack_public_path__ + "cypress.3XNd-Fei.svg";